import { sessionStorageHelper } from '../storage';
export const getSDKConfig = (instanceId) => {
    const storage = sessionStorageHelper(`__klarna_sdk-${instanceId}-config`);
    return storage.get('config');
};
